import React, { useEffect, useState } from "react";
import { getUserRequestCount } from "../../service/api/UserRequestsService";
import { Cost } from "./Cost";



export const CostInfoRedirect = () => {

    const [loading, setLoading] = useState(false);

    const [count, setCount] = useState({
        requestGrades: 0
    });
    const firstCostModal = () => {
        const visible = sessionStorage.getItem("costModalVisible");
        return visible === null;
    }
    const onClose = () => {
        sessionStorage.setItem("costModalVisible", false);
    }

    useEffect(() => {
        const userCount = getUserRequestCount();
        userCount.then((data) => setCount(data));
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1700)
    }, [])

    const showCostModal = () => {
        if (!count.requestGrades && firstCostModal()) {
            return <Cost onClose={onClose} />;
        }
    }

    return (
        <>
            {loading ? " " : <div >{showCostModal()} </div>}
        </>

    )
}